import React from "react";
import { Modal } from "react-bootstrap";
import PropTypes from "prop-types";
import "./Step.css";

import close from "../../assets/svgs/close.svg";
import logout from "../../assets/svgs/log-out.svg";
import "../../assets/css/modal.css";
import { useHistory } from "react-router-dom";

const VerifiedEmail = ({ show, closeModal }) => {
  const history = useHistory();

  return (
    <Modal
      show={show}
      onHide={() => closeModal}
      dialogClassName="modal-smd maxwidth500"
      centered
    >
      <Modal.Body className="p-2">
        <div className="modal-body d-flex justify-content-center align-items-end">
          <button
            type="button"
            className="close-modal-btn"
            data-dismiss="modal"
            aria-label="Close"
            onClick={() => closeModal()}
          >
            <img src={close} width="20" alt="close" />
          </button>
          <div className="text-center" style={{marginTop: '5vh'}}>
            <div className="f40 claim">
                <h1>GREAT!</h1>
            </div>
            <p>Your account has been created.</p>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className="modal-footer no">
        <button
          type="button"
          className="btn btn-danger claim-button btn-block py-0"
          data-dismiss="modal"
          onClick={() => {
            closeModal();
            history.push("/?business_id=" + localStorage.business_id + "&location_id=" + localStorage.location_id);
          }}
        >
            START ORDERING NOW!
        </button>
        <div style={{width:'100%', fontSize:'10pt',textAlign:"center"}}>
            <p>Powered by Warely</p>
        </div>
      </Modal.Footer>
    </Modal>
  );
};
VerifiedEmail.propTypes = {
  closeModal: PropTypes.func.isRequired,
};
export default VerifiedEmail;
